<template>
  <div>

    <Slide :right="true" :burgerIcon="false" :isOpen="isMenuOpen" @closeMenu="closeMenu">
      <router-link :to="{ name: 'profile' }" class="nav-link link-effect-slideup"> <span class="nav-link-inner" data-title="Profiel">Profiel</span> </router-link>
      <router-link :to="{ name: 'access' }" class="nav-link link-effect-slideup"> <span class="nav-link-inner" data-title="Toegang">Toegang</span> </router-link>
      <a :href="docsUrl" target="_blank" class="nav-link link-effect-slideup"> <span class="nav-link-inner" data-title="Documentatie">Documentatie</span> </a>
    </Slide>

    <!-- ======== @Region: body ======== -->
    <div class="page page-index-event navbar-layout-default" data-colour-scheme="pink">
      <a id="#top" href="#content" class="sr-only">Skip to content</a>
      <!-- ======== @Region: #header ======== -->
      <div id="header">
        <div data-toggle="sticky">
          <!--Header & Branding region-->
          <div class="header header-dark bg-dark border-primary sticky-bg-dark">
            <!-- all direct children of the .header-inner element will be vertically aligned with each other you can override all the behaviours using the flexbox utilities (flexbox.htm) All elements with .header-brand & .header-block-flex wrappers will automatically be aligned inline & vertically using flexbox, this can be overridden using the flexbox utilities (flexbox.htm) Use .header-block to stack elements within on small screen & "float" on larger screens use .order-first or/and .order-last classes to make an element show first or last within .header-inner or .headr-block elements -->
            <div class="header-inner container">
              <!--branding/logo -->
              <div class="header-brand">
                <router-link :to="{ name: 'index' }" class="header-brand-text">
                  <h1 class="h2">
                    <span class="header-brand-text-alt">opTV</span>.nu
                  </h1>
                </router-link>
              </div>

              <!-- other header content -->
              <div class="header-block d-flex order-12 align-items-center">
                <a href="#top" class="btn btn-icon btn-white ml-2 order-12 d-lg-none" data-target=".navbar-main" data-direction="right" @click="isMenuOpen = true"> <i class="fa fa-bars"></i> </a>
                <router-link :to="{ name: 'login' }" class="btn btn-primary btn-sm text-uppercase font-weight-bold px-lg-3 py-lg-2 ml-lg-3" v-if="!firebaseUser">Inloggen</router-link>
                <a href="#" @click="logout" class="btn btn-primary btn-sm text-uppercase font-weight-bold px-lg-3 py-lg-2 ml-lg-3" v-if="firebaseUser">Uitloggen</a>
              </div>

              <div class="navbar navbar-expand-md navbar-static-top">
                <!--everything within this div is collapsed on mobile-->
                <div class="navbar-main collapse">
                  <!--main navigation-->
                  <ul class="nav navbar-nav navbar-dark">
                    <li class="nav-item" v-if="firebaseUser">
                      <router-link :to="{ name: 'profile' }" class="nav-link link-effect-slideup"> <span class="nav-link-inner" data-title="Profiel">Profiel</span> </router-link>
                    </li>
                    <li class="nav-item" v-if="firebaseUser">
                      <router-link :to="{ name: 'access' }" class="nav-link link-effect-slideup"> <span class="nav-link-inner" data-title="Toegang">Toegang</span> </router-link>
                    </li>
                    <li class="nav-item">
                      <a :href="docsUrl" target="_blank" class="nav-link link-effect-slideup"> <span class="nav-link-inner" data-title="Documentatie">Documentatie</span> </a>
                    </li>
                  </ul>
                </div>
                <!--/.navbar-collapse -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <transition name="fade">
          <div class="p-0 bg-white">
            <div class="bg-white">
              <div class="container py-5">
                <router-view></router-view>
              </div>
            </div>
          </div>
      </transition>

      <!-- ======== @Region: #footer ======== -->
      <footer id="footer" class="py-3 py-4 border-primary">
        <div class="container">
          <div class="row">
            <div class="col-md-4 d-md-flex justify-content-start align-items-center flex-row">
              <p class="mb-0 text-sm">&copy; opTV.nu 2018-{{ new Date().getFullYear() }}</p>
            </div>
            <div class="col-md-4 d-md-flex justify-content-center align-items-center flex-row">
              <a href="#top" class="text-white op-7 p-2" title="Back to top"><i class="fa fa-chevron-up"></i></a>
            </div>
            <div class="col-md-4 d-md-flex justify-content-end align-items-center flex-row">
              <ul class="list-inline footer-links mb-0 text-sm float-md-right">
                <li class="list-inline-item"><router-link :to="{ name: 'terms-of-service' }">Voorwaarden</router-link></li>
                <li class="list-inline-item"><router-link :to="{ name: 'privacy-policy' }">Privacy</router-link></li>
                <li class="list-inline-item"><router-link :to="{ name: 'contact' }">Contact</router-link></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>

      <!--Hidden elements - excluded from jPanel Menu on mobile-->
      <div class="hidden-elements jpanel-menu-exclude"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import firebase from 'firebase/app'
import 'firebase/auth'

import { Slide } from 'vue-burger-menu'

export default {
  components: {
    Slide
  },
  data () {
    return {
      docsUrl: process.env.DOCS_URL,
      isMenuOpen: false
    }
  },
  methods: {
    logout () {
      firebase.auth().signOut().then(() => {
        this.$store.dispatch('unsetFirebaseUser')
        this.$router.push('/site/login')
      }).catch(err => {
        console.log(err)
      })
    },
    closeMenu () {
      this.isMenuOpen = false
    }
  },
  computed: {
    ...mapState(['firebaseUser'])
  }
}
</script>

<style>
.bm-burger-button {
  position: fixed;
  width: 36px;
  height: 30px;
  left: 36px;
  top: 36px;
  cursor: pointer;
}
.bm-burger-bars {
  background-color: #373a47;
}
.line-style {
  position: absolute;
  height: 20%;
  left: 0;
  right: 0;
}
.cross-style {
  position: absolute;
  top: 12px;
  right: 2px;
  cursor: pointer;
}
.bm-cross {
  background: #bdc3c7;
}
.bm-cross-button {
  height: 24px;
  width: 24px;
}
.bm-menu {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  background-color: rgb(63, 63, 65);
  overflow-x: hidden;
  padding-top: 60px;
  transition: 0.5s;
}
.bm-overlay {
  background: rgba(0, 0, 0, 0.3);
}
.bm-item-list {
  color: #b8b7ad;
  margin-left: 10%;
  font-size: 20px;
}
.bm-item-list > * {
  display: flex;
  text-decoration: none;
  padding: 0.7em;
}
.bm-item-list > * > span {
  margin-left: 10px;
  font-weight: 700;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/DefaultLayout.vue